import * as React from 'react';

const Twitter = (props) => (
  <svg
    width={25}
    height={25}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        d="M24.281 5.738c-.835.37-1.732.62-2.675.733a4.67 4.67 0 0 0 2.048-2.578 9.3 9.3 0 0 1-2.958 1.13 4.66 4.66 0 0 0-7.938 4.25 13.23 13.23 0 0 1-9.602-4.868 4.66 4.66 0 0 0 1.442 6.22 4.646 4.646 0 0 1-2.11-.583v.06a4.66 4.66 0 0 0 3.737 4.568 4.69 4.69 0 0 1-2.104.08 4.66 4.66 0 0 0 4.352 3.234 9.347 9.347 0 0 1-5.786 1.995 9.5 9.5 0 0 1-1.112-.065 13.174 13.174 0 0 0 7.14 2.093c8.57 0 13.255-7.098 13.255-13.254 0-.2-.005-.402-.014-.602a9.47 9.47 0 0 0 2.323-2.41l.002-.003Z"
        fill="#549A9A"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" transform="translate(.639 .8)" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default Twitter;
